import { API_URL } from '../../../../constants/urls.constants';
import { appServiceApi } from '../../../apis/app-service.api';
import { APP_API_TAGS } from '../../../app.constants';
import { invalidateOnSuccess } from '../../../app.utils';
import type {
  GetAllInterviewsParams,
  GetAllInterviewsResponse,
  GetEvaluatedInterviewsParams,
  GetEvaluatedInterviewsResponse,
} from './interview.type';

const { INTERVIEWS, EVALUATED_INTERVIEWS } = APP_API_TAGS;

export const interviewApi = appServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    // POST: Assign Interview
    assignInterview: builder.mutation<any, any>({
      query: (body) => ({
        url: API_URL.interviewAssign,
        method: 'POST',
        body,
      }),
      invalidatesTags: invalidateOnSuccess([INTERVIEWS]),
    }),

    // DELETE: Delete Interview
    deleteInterview: builder.mutation<any, { id: string }>({
      query: ({ id }) => ({
        url: `${API_URL.interviewAssign}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: invalidateOnSuccess([INTERVIEWS]),
    }),

    // GET: All Interviews
    getAllInterviews: builder.query<
      GetAllInterviewsResponse,
      GetAllInterviewsParams
    >({
      query: (params) => ({
        url: API_URL.interviewAssign,
        method: 'GET',
        params,
      }),
      providesTags: [INTERVIEWS],
    }),

    // GET: Evaluated Interviews
    getEvaluatedInterviews: builder.query<
      GetEvaluatedInterviewsResponse,
      GetEvaluatedInterviewsParams
    >({
      query: (params) => ({
        url: `${API_URL.interviewAssign}/evaluated-list`,
        method: 'GET',
        params,
      }),
      providesTags: [EVALUATED_INTERVIEWS],
    }),

    // PATCH: Reschedule Interview
    rescheduleInterview: builder.mutation<any, { id: string; body: any }>({
      query: ({ id, body }) => ({
        url: `${API_URL.interviewAssign}/reschedule/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: invalidateOnSuccess([INTERVIEWS, EVALUATED_INTERVIEWS]),
    }),
  }),
});

export const {
  useAssignInterviewMutation,
  useDeleteInterviewMutation,
  useGetAllInterviewsQuery,
  useGetEvaluatedInterviewsQuery,
  useRescheduleInterviewMutation,
} = interviewApi;
